import TextList from 'common/components/TextList';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    inspirationUrls: string[];
}

interface Props<T> {
    form: ObservableForm<T>;
}

const InspirationUrlsField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
}) => {
    return (
        <Field
            form={form}
            name="inspirationUrls"
            title={__('Link to any inspiration on the Web')}
            render={() => (
                <TextList
                    {...form.attach('inspirationUrls')}
                    placeholder="https://pinterest.com/99designs/"
                />
            )}
        />
    );
};

export default InspirationUrlsField;
